import React from 'react'
import {createRoot} from 'react-dom/client'
import App from './components/App'
import {getAwsConfig} from './services/config'

import {HashRouter} from 'react-router-dom'
import {Provider} from 'react-redux'
import AppErrorBoundary from './components/AppErrorBoundary'
import {store} from './store/store'
import {Amplify} from 'aws-amplify'

import {config, dom} from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'

// Prevent FontAwesome from auto-injecting its CSS into <head>
config.autoAddCss = false

import './types'
import './index.css'

const awsConfig = getAwsConfig()
Amplify.configure(awsConfig)

const lightDOMMount = document.getElementById('appRoot')

if (!lightDOMMount) {
  throw new Error('No #appRoot element found')
}

// Create shadow root
const shadowHost = document.createElement('div')
lightDOMMount.appendChild(shadowHost)

const shadow = shadowHost.attachShadow({mode: 'open'})

const shadowRootDiv = document.createElement('div')
shadow.appendChild(shadowRootDiv)

// Find the script tag that loaded this file
const currentScript = (document.currentScript ||
  [...document.scripts].pop()) as HTMLScriptElement
const baseUrl = new URL(currentScript.src).origin

const link = document.createElement('link')
link.rel = 'stylesheet'
link.href = `${baseUrl}/shadow.css?v=${Date.now()}`
link.onload = () => {
  const root = createRoot(shadowRootDiv)
  root.render(
    <AppErrorBoundary>
      <Provider store={store}>
        <HashRouter>
          <App />
        </HashRouter>
      </Provider>
    </AppErrorBoundary>
  )
}
shadow.appendChild(link)
